/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DataExportStatusFromJSON, DataExportStatusToJSON, } from './DataExportStatus';
/**
 * Check if a given object implements the DataExportDto interface.
 */
export function instanceOfDataExportDto(value) {
    let isInstance = true;
    return isInstance;
}
export function DataExportDtoFromJSON(json) {
    return DataExportDtoFromJSONTyped(json, false);
}
export function DataExportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : DataExportStatusFromJSON(json['status']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'readyAt': !exists(json, 'readyAt') ? undefined : (json['readyAt'] === null ? null : new Date(json['readyAt'])),
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (json['expiresAt'] === null ? null : new Date(json['expiresAt'])),
        'sizeBytes': !exists(json, 'sizeBytes') ? undefined : json['sizeBytes'],
    };
}
export function DataExportDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': DataExportStatusToJSON(value.status),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'readyAt': value.readyAt === undefined ? undefined : (value.readyAt === null ? null : value.readyAt.toISOString()),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt === null ? null : value.expiresAt.toISOString()),
        'sizeBytes': value.sizeBytes,
    };
}
